/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Pr_Wins_5Inputs */

const en_fc_vs_pr_wins_5 = /** @type {(inputs: Fc_Vs_Pr_Wins_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile apps for iPhone and Android, and captions translated into 18 languages.`)
};

/**
* | output |
* | --- |
* | "Mobile apps for iPhone and Android, and captions translated into 18 languages." |
*
* @param {Fc_Vs_Pr_Wins_5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_pr_wins_5 = /** @type {((inputs?: Fc_Vs_Pr_Wins_5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Pr_Wins_5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_pr_wins_5(inputs)
});
export { fc_vs_pr_wins_5 as "fc.vs.pr_wins.5" }